export default "__VITE_ASSET__2ada9fe6__"